import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import Skeleton from 'react-loading-skeleton';
import authStorage from "../../utils/authStorage";
import comingSoon from "../../assets/images/comingSoon.svg"

const Leaderboard = () => {

    const navigate = useNavigate();
    const location = useLocation();

    let subscribedStatus = authStorage.getItem('subscribedStatus');
        
    // If subscribedStatus is falsy, redirect to membership page
    if (subscribedStatus == 'false') {
        window.location = window.location.origin + '/membership';
        return false;
    }

    return (
        <>
            <div className="dark:bg-slate-900 p-6" style={{ height: "100vh" }}>
                <h2 className="mob-header font-medium mb-5">Leaderboard</h2>
                <div class="flex flex-col items-center min-h-screen">
                    <div class="bg-white rounded-lg p-8 w-full">
                        <div className='flex justify-center items-center text-4xl text-gray-500 h-[50vh]'>
                        <img src={comingSoon} />
                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}
export default Leaderboard;